import { useState, useEffect } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { useAppServices } from 'hook/services'
import FormPreview from 'layouts/Pages/FormComponents/FormPreview'
import Loader from 'examples/Loader'
import { Button } from 'antd'

export default function TemplatePerformerPreview() {
  const [formConfig, setFormConfig] = useState({
    title: 'Multi-Step Form',
    description: 'Complete all steps to submit your information',
    primaryColor: '#4f46e5',
    secondaryColor: '#818cf8',
    steps: [],
  })

  const { form_id, loc_id, company_id, app_id } = useParams()
  const Service = useAppServices()
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  console.log('queryParams: ', queryParams)
  const showBack = queryParams.get('showBack') === 'true'

  const handleBack = () => {
    navigate(-1)
  }
  // File upload function
const uploadFile = async (file, desiredPath) => {
  try {
    const form = new FormData();
    form.append('image', file, file.name);
    const { response } = await Service.utils.upload_image({
      toaster: false, // or pass a toaster instance if needed
      payload: form,
      query: `desiredPath=${desiredPath || 'forms'}/${form_id}`,
    });
    console.log('File upload response:', response);
    return response?.data || null;
  } catch (error) {
    console.error('File upload error:', error);
    throw error;
  }
};
  // Custom submission handler if needed
  const handleSubmit = async (payload, formData) => {
    console.log('payload: ', payload)
    setLoading(true)
    try {
      const { response } = await Service.servey.update_cv_levelupstore({ payload })
      return response
    } catch (error) {
      throw error
    } finally {
      setLoading(false)
    }
  }

  const getDesign = async () => {
    setLoading(true)
    const { response } = await Service.servey.get_levelupstore({
      query: `form_id=${form_id}`,
    })
    console.log('response: ', response)
    setLoading(false)

    if (response?.data?.design) {
      setFormConfig({ ...response.data?.design })
    }
  }

  useEffect(() => {
    getDesign()
  }, [])

  if (loading) {
    return <Loader />
  }

  return (
    <div className="w-full max-w-full bg-gray-50 max-h-screen">
      {showBack && (
        <Button onClick={handleBack} className="mb-5 mt-4 ml-4">
          ← Back
        </Button>
      )}
      <div className="flex-1 h-full">
        <FormPreview 
          formConfig={formConfig}
          onSubmit={handleSubmit}
          submitParams={{
            form_id: form_id,
            location_id: loc_id,
            company_id: company_id,
            app_id: app_id,
          }}
          uploadFile={uploadFile}
          mode="preview"
          showHeader={true}
          maxHeight="100vh"
        />
      </div>
    </div>
  )
}

// function FormPreview() {
//   const Service = useAppServices()
//   const { formConfig, formData, setFormData, currentStep, setCurrentStep } =
//     useContext(FormBuilderContext)
//     console.log("formConfig: ", formConfig)
//   const totalSteps = formConfig.steps.length
//   const params = useParams()

//   // Find the current step object
//   const stepObject = formConfig.steps.find((step) => step.id === currentStep) ||
//     formConfig.steps[0] || { fields: [] }

//   // State to track validation errors
//   const [validationErrors, setValidationErrors] = useState({})
//   const [loading, setLoading] = useState(false)

//   // Form reference
//   const formRef = useRef(null) // Added useRef for form reference

//   // Validate current step
//   const validateStep = () => {
//     const currentStepObject = formConfig.steps.find((step) => step.id === currentStep)
//     if (!currentStepObject) return true

//     const errors = {}
//     let isValid = true

//     currentStepObject.fields.forEach((field) => {
//       if (field.required && (!formData[field.id] || formData[field.id].trim() === '')) {
//         errors[field.id] = `${field.label} is required`
//         isValid = false
//       }

//       if (
//         field.type === 'email' &&
//         formData[field.id] &&
//         !formData[field.id].match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)
//       ) {
//         errors[field.id] = 'Please enter a valid email address'
//         isValid = false
//       }
//     })

//     setValidationErrors(errors)
//     return isValid
//   }

//   // Handle field changes
//   const handleChange = (fieldId, value) => {
//     setFormData({
//       ...formData,
//       [fieldId]: value,
//     })

//     // Clear validation error for this field if it exists
//     if (validationErrors[fieldId]) {
//       const newErrors = { ...validationErrors }
//       delete newErrors[fieldId]
//       setValidationErrors(newErrors)
//     }
//   }

//   // Move to next step
//   const nextStep = () => {
//     const currentIndex = formConfig.steps.findIndex((step) => step.id === currentStep)
//     if (currentIndex < formConfig.steps.length - 1) {
//       setCurrentStep(formConfig.steps[currentIndex + 1].id)
//     }
//   }

//   // Move to previous step
//   const prevStep = () => {
//     const currentIndex = formConfig.steps.findIndex((step) => step.id === currentStep)
//     if (currentIndex > 0) {
//       setCurrentStep(formConfig.steps[currentIndex - 1].id)
//     }
//   }

//   // Handle form submission
//   const handleSubmit = async (e, formElement) => {
//     try {
//       setLoading(true)
//       // Prevent default behavior if event is provided
//       if (e && e.preventDefault) {
//         e.preventDefault()
//         e.stopPropagation()
//       }

//       // Use provided formElement or fallback to formRef.current
//       const form = formElement || formRef.current
//       if (!form) {
//         throw new Error('Form reference is not available')
//       }

//       const formDataObj = new FormData(form)
//       const formDataObject = Object.fromEntries(formDataObj.entries())

//       // Handle checkboxes
//       const checkBoxes = Object.keys(formDataObject).filter((key) => {
//         return form.querySelector(`[name="${key}"]`)?.type === 'checkbox'
//       })
//       checkBoxes.forEach((key) => {
//         formDataObject[key] = form.querySelector(`[name="${key}"]`).checked
//       })

//       // Handle file uploads
//       const fileKey = Object.keys(formDataObject).find((key) => {
//         return form.querySelector(`[name="${key}"]`)?.type === 'file'
//       })
//       if (fileKey && formDataObject[fileKey]) {
//         await uploadFile(formDataObject[fileKey]) // Assuming uploadFile is defined
//       }
//       delete formDataObject[fileKey]

//       // Prepare payload
//       const payload = {
//         formValues: { ...formDataObject },
//         form_id: params.id,
//         location_id: params.loc_id,
//         company_id: params.company_id,
//         app_id: params.app_id,
//       }

//       // Call API
//       const { response } = await Service.servey.update_cv_levelupstore({ payload })

//       setLoading(false)
//       return response
//     } catch (error) {
//       setLoading(false)
//       Swal.fire({
//         icon: 'error',
//         title: 'Submission Error',
//         text: 'There was an error submitting the form. Please try again.',
//       })
//       throw error
//     }
//   }

//   // Handle Next button click (validate, submit, then move to next step)
//   const handleNext = async () => {
//     if (!validateStep()) {
//       Swal.fire({
//         icon: 'warning',
//         title: 'Validation Error',
//         text: 'Please fill in all required fields correctly.',
//       })
//       return
//     }

//     try {
//       await handleSubmit(null, formRef.current)
//       nextStep()
//     } catch (error) {
//       console.error('Error in handleNext:', error)
//     }
//   }

//   // Render form field based on type
//   const renderField = (field) => {
//     switch (field.type) {
//       case 'textarea':
//         return (
//           <textarea
//             id={field.id}
//             name={field.id}
//             value={formData[field.id] || ''}
//             onChange={(e) => handleChange(field.id, e.target.value)}
//             placeholder={field.placeholder}
//             className={`block w-full p-2 border rounded-md ${
//               validationErrors[field.id] ? 'border-red-500' : 'border-gray-300'
//             }`}
//             rows={4}
//           />
//         )

//       case 'select':
//         return (
//           <select
//             id={field.id}
//             name={field.id}
//             value={formData[field.id] || ''}
//             onChange={(e) => handleChange(field.id, e.target.value)}
//             className={`block w-full p-2 border rounded-md ${
//               validationErrors[field.id] ? 'border-red-500' : 'border-gray-300'
//             }`}
//           >
//             <option value="">Select an option</option>
//             {field.options?.map((option, idx) => (
//               <option key={idx} value={option}>
//                 {option}
//               </option>
//             )) || []}
//           </select>
//         )

//       case 'checkbox':
//         return (
//           <div className="space-y-2">
//             {field.options?.map((option, idx) => {
//               const checkboxId = `${field.id}-${idx}`
//               const isChecked = formData[field.id]?.includes(option) || false

//               return (
//                 <div key={checkboxId} className="flex items-center">
//                   <input
//                     type="checkbox"
//                     id={checkboxId}
//                     name={field.id}
//                     checked={isChecked}
//                     onChange={(e) => {
//                       const currentValues = formData[field.id] ? [...formData[field.id]] : []
//                       if (e.target.checked) {
//                         handleChange(field.id, [...currentValues, option])
//                       } else {
//                         handleChange(
//                           field.id,
//                           currentValues.filter((val) => val !== option)
//                         )
//                       }
//                     }}
//                     className="h-4 w-4 border-gray-300 rounded text-indigo-600"
//                   />
//                   <label htmlFor={checkboxId} className="ml-2 block text-sm text-gray-700">
//                     {option}
//                   </label>
//                 </div>
//               )
//             }) || []}
//           </div>
//         )

//       case 'radio':
//         return (
//           <div className="space-y-2">
//             {field.options?.map((option, idx) => {
//               const radioId = `${field.id}-${idx}`

//               return (
//                 <div key={radioId} className="flex items-center">
//                   <input
//                     type="radio"
//                     id={radioId}
//                     name={field.id}
//                     value={option}
//                     checked={formData[field.id] === option}
//                     onChange={() => handleChange(field.id, option)}
//                     className="h-4 w-4 border-gray-300 text-indigo-600"
//                   />
//                   <label htmlFor={radioId} className="ml-2 block text-sm text-gray-700">
//                     {option}
//                   </label>
//                 </div>
//               )
//             }) || []}
//           </div>
//         )

//       case 'date':
//         return (
//           <input
//             type="date"
//             id={field.id}
//             name={field.id}
//             value={formData[field.id] || ''}
//             onChange={(e) => handleChange(field.id, e.target.value)}
//             className={`block w-full p-2 border rounded-md ${
//               validationErrors[field.id] ? 'border-red-500' : 'border-gray-300'
//             }`}
//           />
//         )

//       default:
//         return (
//           <input
//             type={field.type}
//             id={field.id}
//             name={field.id}
//             value={formData[field.id] || ''}
//             onChange={(e) => handleChange(field.id, e.target.value)}
//             placeholder={field.placeholder}
//             className={`block w-full p-2 border rounded-md ${
//               validationErrors[field.id] ? 'border-red-500' : 'border-gray-300'
//             }`}
//           />
//         )
//     }
//   }

//   return (
//     <div className="max-w-2xl mx-auto">
//       <div className="bg-white rounded-lg shadow-sm border p-6">
//         <div className="mb-6 text-center">
//           <h2 className="text-2xl font-bold" style={{ color: formConfig.primaryColor }}>
//             {formConfig.title}
//           </h2>
//           <p className="text-gray-600 mt-1">{formConfig.description}</p>
//         </div>

//         {/* Progress indicator */}
//         <div className="mb-8">
//           <div className="flex justify-between">
//             {formConfig.steps.map((step, idx) => (
//               <div
//                 key={step.id}
//                 className="flex flex-col items-center"
//                 style={{ width: `${100 / totalSteps}%` }}
//               >
//                 <div className="flex items-center">
//                   {idx > 0 && (
//                     <div
//                       className="h-1 flex-1"
//                       style={{
//                         backgroundColor:
//                           idx < formConfig.steps.findIndex((s) => s.id === currentStep) + 1
//                             ? formConfig.primaryColor
//                             : '#e5e7eb',
//                       }}
//                     />
//                   )}
//                   <div
//                     className="flex items-center justify-center h-8 w-8 rounded-full"
//                     style={{
//                       backgroundColor:
//                         idx < formConfig.steps.findIndex((s) => s.id === currentStep) + 1
//                           ? formConfig.primaryColor
//                           : idx === formConfig.steps.findIndex((s) => s.id === currentStep)
//                           ? formConfig.secondaryColor
//                           : '#e5e7eb',
//                       color:
//                         idx <= formConfig.steps.findIndex((s) => s.id === currentStep)
//                           ? 'white'
//                           : '#6b7280',
//                     }}
//                   >
//                     {idx < formConfig.steps.findIndex((s) => s.id === currentStep) ? (
//                       <CheckCircle size={16} />
//                     ) : (
//                       <span className="text-xs">{idx + 1}</span>
//                     )}
//                   </div>
//                   {idx < formConfig.steps.length - 1 && (
//                     <div
//                       className="h-1 flex-1"
//                       style={{
//                         backgroundColor:
//                           idx < formConfig.steps.findIndex((s) => s.id === currentStep)
//                             ? formConfig.primaryColor
//                             : '#e5e7eb',
//                       }}
//                     />
//                   )}
//                 </div>
//                 <span
//                   className="text-xs mt-1 text-center"
//                   style={{
//                     color:
//                       idx === formConfig.steps.findIndex((s) => s.id === currentStep)
//                         ? formConfig.primaryColor
//                         : '#6b7280',
//                   }}
//                 >
//                   {step.title}
//                 </span>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Step content */}
//         <div className="mb-6">
//           <h3 className="text-lg font-semibold mb-1" style={{ color: formConfig.primaryColor }}>
//             {stepObject.title}
//           </h3>
//           <p className="text-gray-600 mb-4">{stepObject.description}</p>

//           <form
//             ref={formRef} // Use useRef hook
//             onSubmit={(e) => handleSubmit(e, formRef.current)}
//           >
//             <div className="space-y-4">
//               {stepObject.fields.map((field) => (
//                 <div key={field.id} className="form-group">
//                   <label
//                     htmlFor={field.id}
//                     className="block text-sm font-medium text-gray-700 mb-1"
//                   >
//                     {field.label}
//                     {field.required && <span className="text-red-500 ml-1">*</span>}
//                   </label>

//                   {renderField(field)}

//                   {validationErrors[field.id] && (
//                     <p className="mt-1 text-sm text-red-500">{validationErrors[field.id]}</p>
//                   )}
//                 </div>
//               ))}
//             </div>

//             {/* Navigation buttons */}
//             {formConfig.steps.length ? (
//               <div className="flex justify-between mt-8">
//                 <button
//                   type="button"
//                   onClick={prevStep}
//                   disabled={loading}
//                   className={`px-4 py-2 rounded-md flex items-center gap-1 ${
//                     currentStep === formConfig.steps[0]?.id
//                       ? 'invisible'
//                       : 'bg-white border border-gray-300 hover:bg-gray-50'
//                   }`}
//                 >
//                   <ChevronLeft size={16} />
//                   Previous
//                 </button>

//                 {currentStep === formConfig.steps[formConfig.steps.length - 1]?.id ? (
//                   <button
//                     type="submit"
//                     disabled={loading}
//                     className="px-4 py-2 rounded-md text-white flex items-center gap-1"
//                     style={{ backgroundColor: formConfig.primaryColor }}
//                   >
//                     {loading ? 'Submitting...' : 'Submit'}
//                     <ChevronRight size={16} />
//                   </button>
//                 ) : (
//                   <button
//                     type="button"
//                     onClick={handleNext}
//                     disabled={loading}
//                     className="px-4 py-2 rounded-md text-white flex items-center gap-1"
//                     style={{ backgroundColor: formConfig.primaryColor }}
//                   >
//                     {loading ? 'Processing...' : 'Next'}
//                     <ChevronRight size={16} />
//                   </button>
//                 )}
//               </div>
//             ) : (
//               ''
//             )}
//           </form>
//         </div>
//       </div>
//     </div>
//   )
// }
